import script from "./MeasurementListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeasurementListItem.vue?vue&type=script&setup=true&lang=ts"

import "./MeasurementListItem.vue?vue&type=style&index=0&id=4d05d177&lang=scss"

const __exports__ = script;

export default __exports__